import { Button, Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

export const InstagramLogin = ({ onConnect }: { onConnect: () => void }) => {
	return (
		<div className="flex flex-col gap-6">
			<Text
				styles={style({
					color: 'heading',
					fontSize: 'heading-lg',
					fontWeight: 'bold',
				})}
			>
				Connect Instagram
			</Text>
			<Text
				styles={style({
					color: 'title',
					fontSize: 'title-xl',
				})}
			>
				Connect your Instagram Business account to enable comment management.
			</Text>
			<Button UNSAFE_className="mx-auto" variant="accent" onPress={onConnect}>
				<Text>Connect with Facebook</Text>
			</Button>
			<Text
				styles={style({
					color: 'detail',
					fontSize: 'body-sm',
				})}
			>
				Your Instagram account must be linked to a Facebook Page.
			</Text>
		</div>
	);
};
